import { Link } from "react-router-dom";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";
import { Reveal } from "@/components/site/Reveal";
import { Seo } from "@/components/site/Seo";
import { FinalCTA } from "@/components/site/CTAs";
import { INDUSTRY_ORDER, INDUSTRY_LABELS, INDUSTRIES } from "@/data/industries";

const ForIndex = () => (
  <>
    <Seo
      title="Clearview — built for the way you actually run"
      description="Ten industry-specific landing pages — civil, electrical, manufacturing, distribution, transport, hire, field services, automotive, multi-site, trades."
      path="/for"
    />
    <Header />

    <section className="hero">
      <div className="glow" />
      <div className="container">
        <Reveal>
          <div className="eyebrow eyebrow-light">Built for the way you actually run</div>
          <h1 style={{ marginTop: 16 }}>
            One straight answer.<br />
            <span className="gtext">For your industry.</span>
          </h1>
          <p className="sub">
            Same product, framed for how your business actually makes and loses money — pick the closest fit.
          </p>
        </Reveal>

        <Reveal style={{ marginTop: 44 }}>
          <div className="grid g3" data-testid="for-index-grid">
            {INDUSTRY_ORDER.map((slug) => {
              const d = INDUSTRIES[slug];
              return (
                <Link
                  key={slug}
                  to={`/for/${slug}`}
                  className="card"
                  data-testid={`for-index-card-${slug}`}
                  style={{ textDecoration: "none", color: "inherit", display: "block" }}
                >
                  <div className="cat">
                    <span className="d" style={{ background: "var(--t)" }} />
                    {d.eyebrow}
                  </div>
                  <h3>{INDUSTRY_LABELS[slug]}</h3>
                  <p>{d.decisionsSub}</p>
                  <div className="stake" style={{ color: "#8b5cf6" }}>See the page →</div>
                </Link>
              );
            })}
          </div>
        </Reveal>
      </div>
    </section>

    <FinalCTA
      title="Can you afford the next move?"
      highlight="Ask it."
      body="Connect read-only and get a straight answer on your real numbers — in the next few minutes."
      testIdPrefix="for-index-final"
    />

    <Footer />
  </>
);

export default ForIndex;
